
import axios from 'axios';



export const  axios_tickets_createticket= async(ticket)=>{
    return await axios({method:'POST',url:`/tickets/createticket`,data:ticket,headers:{'Accept':'application/json','Content-Type':'application/json'}}) ;
}

export const  axios_tickets_changestatuticket= async(ticket)=>{
    return await axios({method:'POST',url:`/tickets/changestatuticket`,data:ticket,headers:{'Accept':'application/json','Content-Type':'application/json'}}) ;
}

export const  axios_tickets_gettickets= async(postmail)=>{
    return await  axios({method:'POST',url:`/tickets/gettickets`,data:{'postmail' :postmail},headers:{'Accept':'application/json','Content-Type':'application/json'}})
}

export const  axios_tickets_reaffectationticket= async(newticket)=>{
    return await axios.post(  `/tickets/reaffectationticket/`,newticket);
}

export const  axios_tickets_updateticket= async(newticket)=>{
    return await axios({method:'POST',url:`/tickets/updateticket`,data:{...newticket},headers:{'Accept':'application/json','Content-Type':'application/json'}});
}

